import { useCustom } from '@refinedev/core';
import { UsersRound, ArrowRight } from 'lucide-react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface ReferralStats {
  activeAmbassadors: number;
  referralsThisMonth: number;
  tokensDistributed: number;
}

const ReferralWidget: FC = () => {
  const navigate = useNavigate();

  // Réutilise l'endpoint existant
  const { data } = useCustom<{ data: ReferralStats }>({
    url: '/api/v1/admin/referral/network-stats',
    method: 'get',
    queryOptions: { retry: false },
  });

  const MOCK: ReferralStats = { activeAmbassadors: 24, referralsThisMonth: 7, tokensDistributed: 3200 };
  const stats = data?.data?.data ?? MOCK;

  const items = [
    { label: 'Ambassadeurs actifs', value: stats?.activeAmbassadors ?? 0 },
    { label: 'Filleuls ce mois', value: stats?.referralsThisMonth ?? 0 },
    { label: 'Tokens distribués', value: stats?.tokensDistributed?.toLocaleString('fr-FR') ?? 0 },
  ];

  return (
    <div className="fc-card p-5 flex flex-col justify-between">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-violet-50 dark:bg-violet-900/30">
            <UsersRound className="h-4 w-4 text-violet-600 dark:text-violet-400" />
          </div>
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white">
            Referral Network
          </h3>
        </div>

        <div className="space-y-3">
          {items.map((item) => (
            <div key={item.label} className="flex items-center justify-between">
              <span className="text-xs text-slate-500 dark:text-slate-400">{item.label}</span>
              <span className="text-sm font-semibold text-slate-900 dark:text-white">{item.value}</span>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => navigate('/growth/referral-dashboard')}
        className="mt-4 flex items-center gap-1.5 text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
      >
        Voir détails
        <ArrowRight className="h-3 w-3" />
      </button>
    </div>
  );
};

export default ReferralWidget;
